module.exports = __webpack_public_path__ + "images/花筑奢pr长图_08-2.jpg?v=2d878e22";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_08-2.jpg
 ** module id = 45
 ** module chunks = 1 2
 **/